<script>
    import {Card,Input,Button} from 'svelte-chota';   
    import {aoviSvelte} from 'aovi-svelte'; 
    import {api} from './../lib/api.js'; 
    import user from './../stores/user.js';

    let loading=false;

    const form = aoviSvelte({
        user: '',
        password: ''
    });

    async function signIn(){
        loading=true;

        let result = await api.post('/user/auth',form.get());
        result.error ? form.load(result.error.aovi) : user.fetch();

        loading=false;
    }

</script>

<Card class="center-500">
    <h4 slot="header">Please login</h4>

    <p><Input placeholder="Login" bind:value={$form.user} error={$form.err.user}/></p>
    <p><Input type="password" placeholder="Password" bind:value={$form.password} error={$form.err.password}/></p>

    {#if !$form.valid}
        <div class="errors mt text-error">
        {#each $form.err.toArray() as error}
            <p>{error}</p>
        {/each}
        </div>
    {/if}

    <div slot="footer" class="is-right mt">
        <Button primary on:click={signIn} loading={loading}>Sign in</Button>
    </div>
</Card>

<style>
 .errors p{
     margin:0px;
 }
</style>